import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConceptResponseService {
  private apiUrl = environment.apiUrl + '/concept_responses/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  private currentCR = new BehaviorSubject<any>(null)
  currentCR$ = this.currentCR.asObservable()

  setCurrentCR$(CR: any) {
    this.currentCR.next(CR)
  }

  get(employeeId?: any, periodId?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (employeeId) httpParams = httpParams.set('employeeId', employeeId.toString());
    if (periodId) httpParams = httpParams.set('periodId', periodId.toString());
    return this.http.get(`${this.apiUrl}get`, { params: httpParams });
  }

  getView(reportResponseId: String): Observable<any> {

    let httpParams = new HttpParams();
    if (reportResponseId) httpParams = httpParams.set('reportResponseId', reportResponseId.toString());

    return this.http.get(`${this.apiUrl}getView`, { params: httpParams });
  }

  getTotalByReportResponse(reportResponseId: String): Observable<any> {
    let httpParams = new HttpParams();
    if (reportResponseId) httpParams = httpParams.set('reportResponseId', reportResponseId.toString());
    return this.http.get(`${this.apiUrl}getTotalByReport/`, { params: httpParams });
  }

  getByEC(ECID: any) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('employeeConceptId', ECID.toString());
    return this.http.get(`${this.apiUrl}get`, { params: httpParams });
  }


  /*generatePdfReport(reportResponseId: string): Observable<Blob> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('reportResponseId', reportResponseId);
    return this.http.get(`${this.apiUrl}generatePdfReport`, { params: httpParams, responseType: 'blob' });
  }*/
generatePdfReport(reportResponseId: string): Observable<{ blob: Blob, fileName: string }> {
  let httpParams = new HttpParams().set('reportResponseId', reportResponseId);
  return this.http.get(`${this.apiUrl}generatePdfReport`, {
    params: httpParams,
    responseType: 'blob',
    observe: 'response'
  }).pipe(
    map(response => {
      const fileName = response.headers.get('X-Zip-File-Name') || 'reporte-informe.zip';
      return { blob: response.body as Blob, fileName };
    })
  );
}


  getById(id: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(this.apiUrl + 'get/' + id)
  }
  update(id: string, userData: any): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'update/' + id, userData);
  }
  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save/', userData);
  }
  delete(conceptResponseId: string) {
    return this.http.delete<any>(`${this.apiUrl + 'delete'}/${conceptResponseId}`);
  }

  approve(conceptResponseId: string) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'approve/' + conceptResponseId, {});
  }

  reject(conceptResponseId: string) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'reject/' + conceptResponseId, {});
  }

}
